import React from 'react';
import { ArrowBack } from 'styled-icons/boxicons-regular';
import styled from 'styled-components';
import { Link } from '@reach/router';
import { RFC } from '../state/StateTypes';
import { theme } from 'styles/ThemeProvider';

const BackButton: RFC<{ to: string }> = ({ to }) => (
   <LinkContainer to={to}>
      <ArrowBack size={30} title="Arrow back" fontWeight={300} color={theme.primaryWhite} />
   </LinkContainer>
);

export default BackButton;

const LinkContainer = styled(Link)`
   padding: 8px 9px 9px 8px;
   border-radius: 4px;
   background-color: ${({ theme }) => theme.secondaryBlueDark};
`;
